import { render } from "./answerDetailLine.vue?vue&type=template&id=3f275fd8&scoped=true"
import script from "./answerDetailLine.vue?vue&type=script&lang=js"
export * from "./answerDetailLine.vue?vue&type=script&lang=js"

import "./answerDetailLine.vue?vue&type=style&index=0&id=3f275fd8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f275fd8"]])

export default __exports__